import type { JSX } from 'react';
import { dateTime } from '../lib/format.js';

/** Verze sestavení z gitu (D-314): která revize běží. Tooltip nese celý hash a zprávu commitu. */
export interface Build {
  commit: string | null;
  committedAt: string | null;
  message: string | null;
  builtAt: string | null;
}

export function buildTitle(b: Build | undefined): string {
  if (!b || !b.commit) return 'Revize sestavení není známá (sestaveno bez gitu).';
  return [
    `Commit ${b.commit}`,
    b.message ? `Zpráva: ${b.message}` : null,
    b.committedAt ? `Commit z ${dateTime(b.committedAt)}` : null,
    b.builtAt ? `Sestaveno ${dateTime(b.builtAt)}` : null,
  ]
    .filter(Boolean)
    .join('\n');
}

export function BuildTag({
  build,
  long,
}: {
  build: Build | undefined;
  long?: boolean;
}): JSX.Element {
  const short = build?.commit ? build.commit.slice(0, 7) : 'neznámá';
  const when = build?.committedAt ?? build?.builtAt ?? null;
  return (
    <span
      className="modechip"
      title={buildTitle(build)}
      data-testid="build-tag"
      style={{ fontFamily: 'ui-monospace, monospace' }}
    >
      {long ? 'Verze sestavení: ' : ''}
      {short}
      {when ? ` · ${dateTime(when)}` : ''}
    </span>
  );
}
